import { FC } from 'react';

import { DefaultConfirmationModal } from './components';
import { BookingConfirmationModal } from './components/BookingConfirmationModal';
import { IConfirmationModalProps } from './interfaces';

export const ConfirmationModal: FC<IConfirmationModalProps> = (props) => {
  if (props.type === 'booking') return <BookingConfirmationModal {...props} />;

  return <DefaultConfirmationModal {...props} />;
};
